import { useMemo } from 'react';

export const useIsOnlyCompleted = (tasks: Record<string, string[]>) => {
    return useMemo(() => {
        if (!tasks) return false;
        const keys = Object.keys(tasks);
        const hasCompleted = tasks['completed']?.length > 0;

        const hasOtherTasks = keys.some((key) => key != 'completed' && tasks[key].length > 0);

        return hasCompleted && !hasOtherTasks;
    }, [tasks]);
};
